import type { FetchModelResponse } from '@cian/http-api';

import type { ICanUserCreateRequestResponse } from '../../../repositories/newbuilding-broker/entities/can_user_create_request/CanUserCreateRequestResponse';
import type { TCanUserCreateRequestResponse } from '../../../repositories/newbuilding-broker/v1/can-user-create-request';
import { ResponseError, mapResponseErrors } from '../../../utils/errors';

export function assertResponseError(
  response: TCanUserCreateRequestResponse,
): asserts response is FetchModelResponse<200, 'json', ICanUserCreateRequestResponse> {
  if (response.statusCode === 200) {
    return;
  }

  const { message, errors } = response.response;

  throw new ResponseError({
    domain: 'shared/services/newbuildingBroker/assertResponseError#assertResponseError()',
    message: message as string,
    details: mapResponseErrors(errors as unknown[]),
  });
}
